import { render, staticRenderFns } from "./SpecListChoose.vue?vue&type=template&id=41ba53d4&scoped=true&"
import script from "./SpecListChoose.vue?vue&type=script&lang=js&"
export * from "./SpecListChoose.vue?vue&type=script&lang=js&"
import style0 from "./SpecListChoose.vue?vue&type=style&index=0&id=41ba53d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba53d4",
  null
  
)

export default component.exports